import React from "react"

export default function AgendaHeader({
  clinicId,
  date,
  setDate,
  onNewAppointment,
  loadingClinics = false,
  compact = false
}) {
  const canCreateAppointment = clinicId && !loadingClinics

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        borderRadius: compact ? 14 : 16,
        padding: compact ? 6 : 8,
        marginBottom: compact ? 6 : 8,
        background: compact
          ? "linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)"
          : "linear-gradient(135deg, #0f172a 0%, #1e293b 56%, #1d4ed8 100%)",
        color: "#ffffff",
        boxShadow: compact
          ? "0 8px 18px rgba(15, 23, 42, 0.12)"
          : "0 10px 22px rgba(15, 23, 42, 0.12)"
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: compact ? "minmax(0, 1fr) auto" : "minmax(180px, 240px) auto",
          gap: compact ? 6 : 12,
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%"
        }}
      >
        <input
          type="date"
          aria-label="Fecha de agenda"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          onFocus={(e) => {
            e.currentTarget.style.boxShadow = "0 0 0 3px rgba(99,102,241,0.20)"
            e.currentTarget.style.border = "1px solid rgba(99,102,241,0.48)"
          }}
          onBlur={(e) => {
            e.currentTarget.style.boxShadow = "none"
            e.currentTarget.style.border = "1px solid rgba(255,255,255,0.16)"
          }}
          style={{
            width: "100%",
            minWidth: 0,
            height: compact ? 36 : 38,
            padding: compact ? "0 9px" : "0 11px",
            borderRadius: compact ? 10 : 11,
            border: "1px solid rgba(255,255,255,0.16)",
            background: "#ffffff",
            color: "#0f172a",
            outline: "none",
            fontWeight: 850,
            fontSize: compact ? 12 : 12.5,
            transition: "all 0.18s ease"
          }}
        />

        {canCreateAppointment ? (
          <button
            type="button"
            onClick={onNewAppointment}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)"
              e.currentTarget.style.boxShadow = "0 12px 22px rgba(99,102,241,0.30)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 8px 18px rgba(99,102,241,0.22)"
            }}
            style={{
              height: compact ? 36 : 38,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: compact ? 4 : 6,
              padding: compact ? "0 10px" : "0 18px",
              borderRadius: compact ? 10 : 11,
              border: "none",
              background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
              color: "#ffffff",
              fontWeight: 950,
              fontSize: compact ? 12 : 12.5,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "all 0.18s ease",
              boxShadow: "0 8px 18px rgba(99,102,241,0.22)",
              lineHeight: 1
            }}
          >
            <span style={{ fontSize: compact ? 13 : 14, lineHeight: 1 }}>＋</span>
            {compact ? "Cita" : "Nueva cita"}
          </button>
        ) : null}
      </div>
    </div>
  )
}
